import { Box, Divider, Grid, IconButton, TextField, Typography } from "@material-ui/core";
import { Add, Delete, Remove } from "@material-ui/icons";
import { round } from "lodash";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ItemPriceHistory, ItemTaxHistory } from "shared/types";

const SellingFormItems = ({
  fields,
  remove,
  selectedCurrency,
}: {
  fields: any;
  remove: any;
  selectedCurrency: any;
}) => {
  const { t } = useTranslation();
  const methods = useFormContext();

  const handleQuantityChange = (index: number, delta: number) => {
    const currentQuantity = methods.getValues(`relOrderItem.${index}.quantity`) || 0;
    const newQuantity = Math.max(0, Number(currentQuantity) + delta); // Nem enged negatív értéket
    methods.setValue(`relOrderItem.${index}.quantity`, newQuantity);
  };

  return (
    <>
      <Typography
        style={{
          marginTop: 8,
          fontWeight: "bold",
          fontSize: 16,
        }}
      >
        Kiválasztott termékek:
      </Typography>
      <Grid container spacing={1} style={{ marginTop: 4 }}>
        {fields.map((field: any, index: number) => {
          const priceHistory = field.item.itemPriceHistories.find(
            (price: ItemPriceHistory) =>
              price.isActive && selectedCurrency.id === price?.currency?.id,
          );
          const price = priceHistory?.price ? Number(priceHistory?.price) : 0;
          const tax =
            (field.item?.itemTaxHistories?.find((tax: ItemTaxHistory) => tax.isActive)?.tax
              ?.percent || 0) / 100 || 0;
          const grossPrice = round(price * (1 + tax), 2);

          return (
            <Grid item xs={12} key={field.id}>
              <Typography style={{ flex: 1, fontWeight: "bold", fontSize: 14, paddingBottom: 8 }}>
                {field.item.name}
              </Typography>
              <Box
                display="flex"
                justifyContent="space-between"
                flexWrap={"wrap"}
                alignItems="center"
                gridGap={4}
              >
                <Typography style={{ flex: 1 }}>
                  {t("common:currency", {
                    num: grossPrice * methods.watch(`relOrderItem.${index}.quantity`),
                    cur: selectedCurrency?.postfix,
                  })}
                </Typography>
                <Box display="flex" flexWrap="no-wrap" alignItems="center" gridGap={8}>
                  <IconButton
                    size="small"
                    color="primary"
                    onClick={() => handleQuantityChange(index, -1)}
                  >
                    <Remove />
                  </IconButton>
                  <TextField
                    type="number"
                    InputProps={{
                      endAdornment:
                        field.item.productUnit === "OWN"
                          ? field.item.customUnitTypeName
                          : t(`item.unit.${field.item.productUnit}`),
                    }}
                    {...methods.register(`relOrderItem.${index}.quantity`, {
                      valueAsNumber: true,
                      onChange: e => {
                        const value = Math.max(0, Number(e.target.value)); // Nem enged negatív értéket
                        methods.setValue(`relOrderItem.${index}.quantity`, value);
                      },
                    })}
                    defaultValue={field.quantity}
                    style={{ width: 80, textAlign: "center" }}
                    inputProps={{
                      min: 1,
                      style: { textAlign: "center" },
                    }}
                  />
                  <IconButton
                    size="small"
                    color="primary"
                    onClick={() => handleQuantityChange(index, 1)}
                  >
                    <Add />
                  </IconButton>
                  <IconButton size="small" color="primary" onClick={() => remove(index)}>
                    <Delete />
                  </IconButton>
                </Box>
              </Box>
              <Divider style={{ marginTop: 8 }} />
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};

export default SellingFormItems;
